import { render } from "./MyBooks.vue?vue&type=template&id=63667a4c&scoped=true"
import script from "./MyBooks.vue?vue&type=script&lang=js"
export * from "./MyBooks.vue?vue&type=script&lang=js"

import "./MyBooks.vue?vue&type=style&index=0&id=63667a4c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63667a4c"]])

export default __exports__